<!-- src/components/NavBar.vue -->
<template>
  <nav :class="navbarClass">
    <div class="container-fluid">
      <img
        :src="currentLogo"
        alt="logo"
        height="50"
        class="me-3"
      >

      <!-- 햄버거 메뉴 버튼 (모바일) -->
      <button
        class="navbar-toggler"
        type="button"
        aria-label="Toggle navigation"
        @click="toggleMenu"
      >
        <span class="navbar-toggler-icon" />
      </button>

      <div
        id="navbarNavAltMarkup"
        class="collapse navbar-collapse"
        :class="{ show: isMenuOpen }"
      >
        <ul class="ms-3 navbar-nav">
          <li
            class="nav-item"
            :class="{ active: isActive('/main/monitor') }"
          >
            <router-link
              :class="linkClass"
              to="/main/monitor"
              @click="closeMenu"
            >
              모니터링
            </router-link>
          </li>
          <li
            class="nav-item"
            :class="{ active: isActive('/main/search') }"
          >
            <router-link
              :class="linkClass"
              to="/main/search"
              @click="closeMenu"
            >
              검색
            </router-link>
          </li>
          <li
            class="nav-item"
            :class="{ active: isActive('/main/device') }"
          >
            <router-link
              :class="linkClass"
              to="/main/device"
              @click="closeMenu"
            >
              디바이스 관리
            </router-link>
          </li>
          <li
            class="nav-item"
            :class="{ active: isActive('/main/event') }"
          >
            <router-link
              :class="linkClass"
              to="/main/event"
              @click="closeMenu"
            >
              이벤트 관리
            </router-link>
          </li>
          <li
            class="nav-item"
            :class="{ active: isActive('/main/admin') }"
          >
            <router-link
              :class="linkClass"
              to="/main/admin"
              @click="closeMenu"
            >
              시스템 관리
            </router-link>
          </li>
          <li class="nav-item">
            <a
              href="#"
              :class="linkClass"
              @click.prevent="logOut"
            >로그아웃</a>
          </li>
        </ul>
      </div>

      <button
        id="themeToggle"
        type="button"
        class="ms-2 btn btn-falcon-primary btn-sm"
        style="width:100px"
        @click="themeStore.toggleTheme"
      >
        {{ themeStore.theme === 'dark' ? 'Dark' : 'Light' }}
      </button>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import {useRouter, useRoute } from 'vue-router'
import slogo_white from '@/assets/images/smartlink_logo_1.png'
import slogo_dark from '@/assets/images/smartlink_logo_2.png'
import { useThemeStore } from '../stores/themeStore'
import axios from 'axios';

const router = useRouter()
const route = useRoute()
const themeStore = useThemeStore()

// 모바일 메뉴 토글 상태
const isMenuOpen = ref(false)

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

const closeMenu = () => {
  isMenuOpen.value = false
}

// 현재 경로가 주어진 경로와 일치하는지 확인
const isActive = (path: string) => {
  return route.path === path
}

async function logOut() {
  console.log('Logging out...')
  
  try {
    // const response = await axios.get('/api/logout');
    const response =  await axios.get('/api/logout', { withCredentials: true });
    router.push('/login')
    if (response.data.success) {
      //console.log('로그인 성공:', response.data.user);
      //router.push('/main/monitor')
    } else {
      //console.error('로그인 실패:', response.data.message);
    }
  } catch (error) {
    console.error('로그인 요청 에러:', error);
  }
}

const navbarClass = computed(() => {
    return themeStore.isDark
        ? 'navbar navbar-expand-md navbar-dark bg-dark fixed-top'
        : 'navbar navbar-expand-md navbar-light bg-primary fixed-top'
});

const linkClass = computed(() => {
  return themeStore.isDark
    ? 'nav-link text-gray fw-semibold'
    : 'nav-link text-light fw-semibold'
})

const currentLogo = computed(() => {
  return themeStore.isDark ? slogo_dark : slogo_white
})

</script>

<style scoped>
/* 라이트 테마 */
.theme-light .navbar-nav .nav-item.active > .nav-link {
  color: #007bff !important; /* 밝은 파랑 */
}

/* 다크 테마 */
.theme-dark .navbar-nav .nav-item.active > .nav-link {
  color: #00d9ff !important; /* 네온 파랑 */
}

.navbar-nav .nav-item.active > .nav-link {
  font-weight: bold;
  color: #00d9ff !important;
}
</style>
